import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";
import { TextBtn } from "../components/form/text-btn";

function NotFound() {
  const { t } = useTranslation();
  const error = useRouteError() as any; // TypeScript-safe
  return <>

      <FullScreenError msg={error.message} />
 
  </>
}
export default NotFound;


const FullScreenError = ({ msg }: any) => {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-io-white w-full h-full">
      <div className="w-[90%] sm:w-[40%] h-auto rounded-2xl flex flex-col items-center">
        <h1 className="text-[2rem] sm:text-[4rem] text-io-black text-center mb-[1rem]">
          OOPS! Something went wrong!
        </h1>

        <img
          className="w-full h-[200px] sm:h-[300px] object-contain object-center rounded-lg pointer-events-none"
          src={require("../assets/images/something-went-wrong.png")}
          alt="Error Illustration"
        />

        <h2 className="text-center text-[1rem] sm:text-[2rem] text-io-gray-9d my-[1rem] mb-[3rem]">
          <span className="font-bold"> Error Cause : </span>“{msg}”
        </h2>

        <div className="flex justify-center">
          <TextBtn
            label="Retry"
            btnType="button"
            handleClick={() => window.location.reload()}
            btnStyle="fill-primary"
          />
        </div>
      </div>
    </div>
  );
};
